<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <h1>Simulador de consumo</h1>
      <p> {{ datosSimulador.TextoAyuda }}</p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Simular consumo por contrato</h2>
          <fieldset>
            <legend class="sr-only">Formulario simular consumo</legend>
            <div
              class="row"
              *ngIf="!contrato.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionSuministro'"
                  [setLabel]="'Dirección suministro'"
                  [setValue]="direccionSuministro"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="direccionSuministro = $event"
                ></sacyr-input>
              </div>
            </div>

            <div
              class="row"
              *ngIf="!contrato.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'contrato'"
                  [setLabel]="'Contrato'"
                  [setValue]="contratoCod.toString()"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="contratoCod = parseStringToInt($event)"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'consumo'"
                  [setLabel]="getConsumo(datosSimulador)"
                  [setValue]="consumo"
                  [setRequired]="true"
                  [setError]="consumoInputError ? 'Indique un consumo valido' : ''"
                  (outValue)="consumo = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'numHab'"
                  [setLabel]="'Nº habitantes en el suministro'"
                  [setValue]="numHab"
                  [setRequired]="true"
                  [setError]="numHabInputError ? 'Introduza un número' : ''"
                  (outValue)="numHab = $event"
                ></sacyr-input>
              </div>
            </div>

          </fieldset>
        </form>
      </div>
      <div
        class="input-form input-button"
        *ngIf="!contrato.Ficticio"
      >
        <button
          type="submit"
          (click)="enviarSimulacion()"
          class="btn-default"
          value=""
        >Calcular</button>
      </div>
    </section>
  </div>

  <!-- MODAL -->
  <sacyr-modal
    [setTemplateRef]="modal_content"
    [showModal]="showModal()"
    (closeModal)="closeModal()"
  ></sacyr-modal>

  <ng-template #modal_content>

    <ng-container *ngIf="numHabInputError === false && consumoInputError === false">

      <form
        class=""
        id="form"
        method="get"
        action=""
      >
        <h2 class="line">Resultado simulación consumo</h2>
        <fieldset>
          <legend class="sr-only">Formulario simular consumo</legend>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'consumoHab'"
                [setLabel]="'Consumo por habitante/día (Litros)'"
                [setValue]="datosSimulador.CnsHabDia"
                [setRequired]="true"
                [setReadOnly]="true"
              ></sacyr-input>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'total'"
                [setLabel]="'Total cálculo (€)'"
                [setValue]="datosSimulador.ImporteTotal"
                [setRequired]="true"
                [setReadOnly]="true"
              ></sacyr-input>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'mensajeSimulacion'"
                [setLabel]="''"
                [setValue]="datosSimulador.consumoAltoBajo"
                [setRequired]="true"
                [setReadOnly]="true"
              ></sacyr-input>
            </div>
          </div>

          <div
            class="scy-table"
            *ngIf="DatosObtenidos === true"
          >
            <div
              id="tabla-facturas_wrapper"
              class="dataTables_wrapper no-footer"
            >
              <ng-container *ngIf="isMobile; else elseTemplate">

                <div
                  class="table-detail-expanded"
                  *ngFor="let row of rows"
                >

                  <div class="row with-background">
                    <label class="row-detail-flex-title">Servicio</label>
                    <div class="row-detail-flex-data">
                      {{ getRowItem(row).servicio }}
                    </div>
                  </div>

                  <div class="row with-background">
                    <label class="row-detail-flex-title">Importe</label>
                    <div class="row-detail-flex-data">
                      {{ getRowItem(row).importeServicio | currency: 'EUR' }}
                    </div>
                  </div>

                  <div class="row with-background">
                    <label class="row-detail-flex-title">IVA</label>
                    <div class="row-detail-flex-data">
                      {{ getRowItem(row).impuesto }}
                    </div>
                  </div>

                  <div class="row with-background">
                    <label class="row-detail-flex-title">Total</label>
                    <div class="row-detail-flex-data">
                      {{ getRowItem(row).importeTotal | currency: 'EUR' }}
                    </div>
                  </div>

                </div>

              </ng-container>
              <ng-template #elseTemplate>

                <!-- NGX-DATATABLE -->

                <ngx-datatable
                  #myTable
                  class="material"
                  [ngClass]="{'fullscreen': _tableFullscreen}"
                  [columnMode]="_columnMode"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="50"
                  [scrollbarV]="true"
                  [rows]="rows"
                >
                  <ngx-datatable-column
                    name="servicio"
                    [flexGrow]="1"
                    [minWidth]="100"
                    [sortable]="false"
                  >
                    <ng-template ngx-datatable-header-template>
                      <span class="not-sortable">Servicio</span>
                    </ng-template>

                    <ng-template
                      let-row="row"
                      let-value="value"
                      ngx-datatable-cell-template
                    >
                      {{ getRowItem(row)['Servicio'] }}
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name="ImporteServicio"
                    [flexGrow]="1"
                    [minWidth]="100"
                    [sortable]="false"
                  >
                    <ng-template ngx-datatable-header-template>
                      <span class="not-sortable">Importe</span>
                    </ng-template>

                    <ng-template
                      let-row="row"
                      let-value="value"
                      ngx-datatable-cell-template
                    >
                      {{ getRowItem(row)['ImporteServicio'] }} €
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name="Impuesto"
                    [flexGrow]="1"
                    [minWidth]="100"
                    [sortable]="false"
                  >
                    <ng-template ngx-datatable-header-template>
                      <span class="not-sortable">IVA</span>
                    </ng-template>

                    <ng-template
                      let-row="row"
                      let-value="value"
                      ngx-datatable-cell-template
                    >
                      {{ getRowItem(row)['Impuesto'] }}%
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column
                    name="ImporteTotal"
                    [flexGrow]="1"
                    [minWidth]="100"
                    [sortable]="false"
                  >
                    <ng-template ngx-datatable-header-template>
                      <span class="not-sortable">Total</span>
                    </ng-template>

                    <ng-template
                      let-row="row"
                      let-value="value"
                      ngx-datatable-cell-template
                    >
                      {{ getRowItem(row)['ImporteTotal'] }} €
                    </ng-template>
                  </ngx-datatable-column>

                </ngx-datatable>

              </ng-template>
            </div>
          </div>
        </fieldset>

        <h2 class="line">Parámetros de la simulación</h2>
        <fieldset>
          <legend class="sr-only">Formulario simular consumo</legend>

          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'consumoHab'"
                [setLabel]="'Consumo total simulación'"
                [setValue]="datosSimulador.Consumo"
                [setRequired]="true"
                [setReadOnly]="true"
                [setError]="consumoInputError ? 'Indique un consumo válido' : ''"
              ></sacyr-input>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'total'"
                [setLabel]="'Habitantes en el suministro'"
                [setValue]="datosSimulador.NumHab"
                [setRequired]="true"
                [setReadOnly]="true"
                [setError]="numHabInputError ? 'Indique un número de habitantes válido' : ''"
              ></sacyr-input>
            </div>

          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6">
              <sacyr-input
                [setType]="'text'"
                [setName]="'calibre'"
                [setLabel]="'Calibre (mm)'"
                [setValue]="datosSimulador.Calibre"
                [setRequired]="true"
                [setReadOnly]="true"
              ></sacyr-input>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-6">
              <br />
              <button
                (click)="descargarSimulacion()"
                type="button"
                class="btn-default"
                value=""
              >Descargar resultado simulación</button>
            </div>
          </div>
        </fieldset>
      </form>

    </ng-container>

  </ng-template>
